const s = {
  name: "CodeBackup",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,2h35V0H0V2z"/>
		<path class="st0" d="M5,38h16v-2H5V38z"/>
		<path class="st0" d="M40,14H0v-2h40V14z"/>
		<path class="st0" d="M0,26h21v-2H0V26z"/>
		<path class="st0" d="M11,8H0V6h11V8z"/>
		<path class="st0" d="M19,8h21V6H19V8z"/>
		<path class="st0" d="M16,32H0v-2h16V32z"/>
		<path class="st0" d="M14,8h2V6h-2V8z"/>
		<path class="st0" d="M21,32h-2v-2h2V32z"/>
		<path class="st0" d="M38,2h2V0h-2V2z"/>
		<path class="st0" d="M2,38H0v-2h2V38z"/>
		<path class="st0" d="M38,20h2v-2h-2V20z"/>
		<path class="st0" d="M21,20h-2v-2h2V20z"/>
		<path class="st0" d="M0,20h2v-2H0V20z"/>
		<path class="st0" d="M16,20H5v-2h11V20z"/>
		<path class="st0" d="M24,20h11v-2H24V20z"/>
		<path class="st0" d="M25,32v-8h2v3.4c1.2-2,3.5-3.4,6-3.4c3.9,0,7,3.1,7,7s-3.1,7-7,7c-1.9,0-3.7-0.8-5-2.1l1.4-1.4
			c0.9,0.9,2.1,1.5,3.5,1.5c2.8,0,5-2.2,5-5s-2.2-5-5-5c-2.4,0-4.4,1.7-4.9,4H33v2H25z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CodeBackup
};
